import { createAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { SingleValue } from 'react-select';

interface ThemeState {
  selectedTheme: SingleValue<IDropdownSelectOptionItem>;
  themeOptionsList: IDropdownSelectOptionItem[];
}

const defaultThemes: IDropdownSelectOptionItem[] = [
  { value: 'coley', label: 'Coley Theme' },
  { value: 'dark', label: 'Dark Theme' },
];

export const THEME_UI_FEATURE_KEY = 'themeUI';

//region ACTIONS
export const setSelectedTheme = createAction<SingleValue<IDropdownSelectOptionItem>>('SET_SELECTED_THEME');
//endregion

const initialState: ThemeState = {
  selectedTheme: defaultThemes[0],
  themeOptionsList: defaultThemes,
};

const themeUISlice = createSlice({
  name: THEME_UI_FEATURE_KEY,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSelectedTheme, (state, { payload }) => {
      state.selectedTheme = payload;
    });
  },
});

// Export the action for dispatching
export const themeUIReducer = themeUISlice.reducer;

export const getThemeUIState = (rootState: RootState) => rootState[THEME_UI_FEATURE_KEY];

export const themeUISelectors = {
  getSelectedTheme: (state: RootState) => getThemeUIState(state).selectedTheme,
  getThemesOptionsList: (state: RootState) => getThemeUIState(state).themeOptionsList,
};
